<form [formGroup]="textForm" autocomplete="off" class="form-container">
  <div class="text-input-container global-transition" [ngClass]="{'invalid-config-name': configForm.text.invalid}">
    <label class="text-label" for="text">
      {{ 'view_translations.' + configurationData.label | translate }}
      <input id="text" class="text-input global-transition" formControlName="text" name="text" placeholder="{{'view_translations.input_label' | translate}}" />
    </label>
  </div>
  <div *ngIf="configForm.text.invalid" class="error-message">{{ 'view_translations.invalid_player_id' | translate }}</div>
</form>
